// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import users01Icon from "@/assets/icons/users-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Users01IconProps = Omit<IconProps, "name">;

export function Users01Icon(props: Users01IconProps): React.ReactNode {
  return <Icon name={users01Icon} {...props} />;
}
